export const SRSubscriptionPricingFormName = 'sr-subscription-pricing';

export enum SRSubscriptionPricingFormFields {
  Pricing = 'pricing',
}
